import { Modal, VStack } from '@genial/components';
import { BoxBorder, Spacing } from '@genial/design-tokens';
import { TreasuryOfferBaseEntity } from '@genial/services';
import { ResponsesTreasuryMarketResponse } from '@genial/services/dist/models';
import { useBreakpointValue } from '@genial/utils';
import { Modal as NBModal } from 'native-base';
import React from 'react';
import { useRecoilValue } from 'recoil';

import {
  directTreasuryDetailSelectedState,
  directTreasuryMarketStatusState,
} from '../../../../store/product/atom';

import { DirectTreasuryDetailsHeader } from './components/DirectTreasuryDetailsHeader';
import { DirectTreasuryDetailsInfos } from './components/DirectTreasuryDetailsInfos';
import { DirectTreasuryDetailsMarket } from './components/DirectTreasuryDetailsMarket';
import { DirectTreasuryDetailsPrincipalText } from './components/DirectTreasuryDetailsPrincipalText';

export interface DirectTreasuryDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
  offer?: TreasuryOfferBaseEntity;
  marketStatus?: ResponsesTreasuryMarketResponse;
}

export type DirectTreasuryDetailsModalComponentsProps = DirectTreasuryDetailsModalProps & {
  item: TreasuryOfferBaseEntity;
  directTreasuryMarketStatus: ResponsesTreasuryMarketResponse;
};

export const DirectTreasuryDetailsModal: React.FC<DirectTreasuryDetailsModalProps> = ({
  isOpen,
  onClose,
  offer,
  marketStatus,
}) => {
  const isDesktop = useBreakpointValue({ base: false, lg: true });
  const productSelected = useRecoilValue(directTreasuryDetailSelectedState);
  const productItem = offer || productSelected;

  const directTreasuryMarketStatus = useRecoilValue(directTreasuryMarketStatusState);
  const marketStatusItem = marketStatus || directTreasuryMarketStatus;

  if (!productItem || !marketStatusItem.marketStatus) {
    return <></>;
  }

  const componentsProps = {
    isOpen,
    onClose,
    item: productItem,
    directTreasuryMarketStatus: marketStatusItem,
  };

  const modalContentDesktopProps = {
    maxH: 'full',
    maxW: '900px',
    borderRadius: BoxBorder.heavy,
  };

  const modalContentMobileProps = {
    w: 'full',
    marginBottom: 0,
    marginTop: 'auto',
  };

  const modalContentProps = isDesktop ? modalContentDesktopProps : modalContentMobileProps;

  return (
    <Modal testId="modal-direct-treasury-content-details" isOpen={isOpen} onClose={onClose}>
      <NBModal.Content maxW={'full'} {...modalContentProps}>
        <VStack p={Spacing['inset.md']} space={Spacing['stack.xxxs']}>
          <DirectTreasuryDetailsHeader {...componentsProps} />
          <DirectTreasuryDetailsMarket {...componentsProps} />
          <DirectTreasuryDetailsPrincipalText {...componentsProps} />
          <DirectTreasuryDetailsInfos {...componentsProps} />
        </VStack>
      </NBModal.Content>
    </Modal>
  );
};
